<template>
  <div class="drawer">
    <div class="drawer-container">
      <el-tabs
        v-model="activeName"
        @tab-click="handleClickTab"
        v-loading="loading"
        ><el-tab-pane :label="$t('text.baseInfo')" name="detail">
          <div class="drawer-content">
            <el-form
              ref="rentForm"
              :model="rent"
              class="box"
              label-width="100px"
            >
              <fieldset class="mgb15">
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('clean.serialNo')">
                      {{ rent.serialNo }}
                    </el-form-item>
                  </el-col>

                  <el-col :span="8">
                    <el-form-item :label="$t('menu.shops')">{{
                      rent.shopName
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.owner')">{{
                      rent.ownerName
                    }}</el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.createAt')">{{
                      rent.createAt
                    }}</el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset>
                <legend>{{ $t("text.remark") }}</legend>
                <raw-html :content="rent.remark" />
              </fieldset>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('text.log')" name="log">
          <div class="drawer-content with-tab">
            <div class="box">
              <el-timeline>
                <el-timeline-item
                  v-for="(log, index) in logs"
                  :key="index"
                  :timestamp="log.doAt"
                >
                  <span v-if="log.doBy != null" style="color: #909399">{{
                    log.doBy
                  }}</span>
                  <raw-html :content="log.content"></raw-html>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import ThumbnailText from "@/components/ThumbnailText";
import RawHtml from "@/components/RawHtml";
import Rent from "@/api/rent.js";
import Log from "@/api/log.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    ThumbnailText,
    RawHtml,
  },
  data() {
    return {
      activeName: "detail",
      rent: {},
      logs: [],
    };
  },
  mounted() {
    // 根据id请求bargain
  },
  created() {
    const self = this;
    self.handleClickTab();
  },
  methods: {
    handleClickTab(tab, event) {
      if (this.activeName == "detail") {
        this.getRent();
      }
      if (this.activeName == "log") {
        this.getLogs();
      }
    },
    getRent() {
      const self = this;
      self.loadingStart();
      Rent.findById(self.id).then(function (res) {
        if (res.data.code === 200) {
          self.rent = res.data.entity;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
    getLogs() {
      const self = this;
      Log.forEntity("Rent", self.id).then(function (res) {
        self.logs = res.data;
      });
    },
  },
};
</script>